import { Component, Inject} from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'app-imagepopup',
    templateUrl: './imagepopup.component.html',
    styleUrls: ['./imagepopup.component.scss'],
    standalone: false
})
export class ImagepopupComponent {
  mediaType: string = '';

  constructor(
    public dialogRef: MatDialogRef<ImagepopupComponent>, @Inject(MAT_DIALOG_DATA) public url: string, private http: HttpClient) {}

    ngOnInit() {
      this.detectMediaType(this.url)
      .then((type: any) => {
        this.mediaType = type;
      });
    }

    onNoClick(): void {
      this.dialogRef.close();
    }

    getMediaType(url: string): string {
      const extension = url.split('.').pop()?.toLowerCase();
      if (extension) {
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(extension)) {
          return 'image';
        } else if (['mp4', 'webm', 'ogg', 'mov'].includes(extension)) {
          return 'video';
        }
      }
      return 'unknown'; // Can also return null or throw an error based on your needs
    }

    async detectMediaType(url: string): Promise<'Image' | 'Video' | 'unknown'> {
      return await this.http.head(url, { observe: 'response' }).toPromise()
        .then((response: any) => {
          const contentType = response.headers.get('Content-Type');
          if (contentType) {
            if (contentType.startsWith('image/')) {
              return 'Image';
            } else if (contentType.startsWith('video/')) {
              return 'Video';
            }
          }
          return 'unknown';
        })
        .catch(() => 'unknown');
    }
}
